import { ip_back } from "../config";

function authHeaders() {
  const token =
    (typeof window !== "undefined" && localStorage.getItem("token")) || "";
  return token
    ? { Authorization: token, "Content-Type": "application/json" }
    : { "Content-Type": "application/json" };
}

async function parseJson(resp) {
  try {
    return await resp.json();
  } catch {
    return {};
  }
}

export async function probePoseBenchmark({ teId, videoUrl, messageId }) {
  const resp = await fetch(`${ip_back}api/mobileAPI/pose/benchmark/probe`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({
      te_id: teId,
      video_url: videoUrl,
      message_id: messageId || undefined,
    }),
  });
  const json = await parseJson(resp);
  if (!resp.ok || json?.status === false) {
    throw new Error(json?.message || "Could not check calibration");
  }
  return json.data;
}

export async function startPoseBenchmark({
  teId,
  videoUrl,
  messageId,
  poseFps = 15,
}) {
  const resp = await fetch(`${ip_back}api/mobileAPI/pose/benchmark`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({
      te_id: teId,
      video_url: videoUrl,
      message_id: messageId || undefined,
      pose_fps: poseFps,
    }),
  });
  const json = await parseJson(resp);
  if (!resp.ok || json?.status === false) {
    const err = new Error(json?.message || "Could not start benchmark");
    err.code = json?.code;
    throw err;
  }
  return json.data;
}

export async function getPoseBenchmark(benchId) {
  const q = new URLSearchParams({ bench_id: benchId });
  const resp = await fetch(
    `${ip_back}api/mobileAPI/pose/benchmark?${q.toString()}`,
    { method: "GET", headers: authHeaders() }
  );
  const json = await parseJson(resp);
  if (!resp.ok || json?.status === false) {
    throw new Error(json?.message || "Could not load benchmark");
  }
  return json.data;
}

export async function pollPoseBenchmark(
  benchId,
  { onUpdate, signal, maxAttempts = 900 } = {}
) {
  for (let i = 0; i < maxAttempts; i += 1) {
    if (signal?.aborted) throw new DOMException("Aborted", "AbortError");
    const data = await getPoseBenchmark(benchId);
    onUpdate?.(data);
    if (
      data.status === "complete" ||
      data.status === "failed" ||
      data.status === "partial"
    ) {
      return data;
    }
    await new Promise((r) => setTimeout(r, i === 0 ? 800 : 2000));
  }
  throw new Error("Benchmark timed out");
}
